import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0a1229] text-white py-10 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Company Info */}
          <div>
            <h3
              className="text-[16px] md:text-[20px] font-bold text-white mb-4 md:mb-6"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              가경 센트럴 더 플래티넘
            </h3>
            <p className="text-[12px] md:text-[14px] text-gray-400 leading-relaxed">
              가경동의 새로운 랜드마크<br />
              가경 센트럴 더 플래티넘
            </p>
          </div>

          <div>
            <h3 className="text-[14px] md:text-[17px] font-bold mb-3 md:mb-4">빠른 메뉴</h3>
            <div className="space-y-2 md:space-y-2.5">
              <Link to="/business/intro" className="block text-[12px] md:text-[14px] text-gray-400 hover:text-white transition-colors whitespace-nowrap">사업소개</Link>
              <Link to="/location/environment" className="block text-[12px] md:text-[14px] text-gray-400 hover:text-white transition-colors whitespace-nowrap">입지환경</Link>
              <Link to="/complex/layout" className="block text-[12px] md:text-[14px] text-gray-400 hover:text-white transition-colors whitespace-nowrap">단지배치도</Link>
              <Link to="/floor-plan/types" className="block text-[12px] md:text-[14px] text-gray-400 hover:text-white transition-colors whitespace-nowrap">평형안내</Link>
            </div>
          </div>

          <div>
            <h3 className="text-[14px] md:text-[17px] font-bold mb-3 md:mb-4">문의</h3>
            <div className="space-y-2 md:space-y-3">
              <a
                href="tel:1555-5475"
                onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
                className="flex items-center gap-2 text-[13px] md:text-[15px] text-gray-400 hover:text-white transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                1555-5475
              </a>
              <p className="text-[12px] md:text-[14px] text-gray-400 leading-relaxed">
                모델하우스 주소 - 충청북도 청주시 흥덕구 비하동 35-28
                <br /><br />
                모델하우스 운영시간 10:00 - 18:00 (연중무휴)
                <br /><br />
                주차안내 - 해당 건물에 주차장 완비
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          </div>
        </div>
      </div>
    </footer>
  );
}
